<form ngFormModel="form" novalidate>
    <h2>Reset Password</h2>
     <b2c-content-host [b2cFrameSource]="b2cFrameSource" [b2cFrameHeight]="b2cFrameHeight"></b2c-content-host>
</form>
